<template>
  <general-text-field
    label="Text"
    dense autofocus
    v-bind:disabled="isImmutable"
    v-model="$_text"
  >
  </general-text-field>
</template>

<script>
import NoteSegmentData from '../../../modules/segmentDataTypes/NoteSegmentData.js';
import SegmentContentDataInputDefinition from '../../../modules/SegmentContentDataInputDefinition.js';
import GeneralTextField from './GeneralTextField.vue';

export const NoteSegmentContentDataInputDefinition = new SegmentContentDataInputDefinition(
  'NoteSegmentContentDataInput',
  NoteSegmentData.contentData,
);

export default {
  model: {
    event: 'update',
    prop: 'timelineSegmentContentData'
  },

  components: {
    GeneralTextField,
  },

  props: {
    isImmutable:                { type: Boolean,                     required: true },
    timelineSegmentContentData: { type: NoteSegmentData.contentData, required: true },
  },

  computed: {
    $_noteData: {
      get()         { return this.timelineSegmentContentData },
      set(noteData) { this.$emit('update', noteData) },
    },

    $_text: {
      get()     { return this.$_noteData.text },
      set(text) {
        let noteData = this.$_noteData.clone();
        noteData.text = text;
        this.$_noteData = noteData;
      },
    },
  },
}
</script>